export default "__VITE_ASSET__8a56b91e__"